import { useEffect, useState } from "react";

import { API } from "aws-amplify";
import Fund from "../types/Fund";
import SkeletonTable from "../components/SkeletonTable";
import { authState } from "../state/atoms";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";

const Funds = (props: any): JSX.Element => {
  const navigate = useNavigate();
  const [auth]: [any, any] = useRecoilState(authState);

  const [funds, setFunds] = useState([]);
  const [loading, setLoading] = useState(true);

  // get funds
  useEffect(() => {
    (async () => {
      const fundsResponse = await API.get("submissions", `/submissions`, {
        queryStringParameters: {
          user: auth.attributes.email,
          all: true
        }
      });
      const funds = fundsResponse.data.map((fund: any): Fund => {
        return {
          fundId: fund.SK.replace("CONFIG#", ""),
          name: fund.name,
          applicationLink: fund.applicationLink,
          created: new Date(fund.createdAt).toLocaleString()
        };
      });
      console.log("funds", funds);
      setLoading(false);
      setFunds(funds);
    })();
  }, [auth]);

  return (
    <div className="min-h-full">
      <div className="pb-32">
        <header className="py-10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-3xl font-bold text-white mb-4">All Funds</h1>
            <p className="text-white">
              This page lists all funds that you have access to participate in.
            </p>
          </div>
        </header>
      </div>
      {loading ? (
        <SkeletonTable />
      ) : (
        <main className="-mt-32 pb-48">
          <div className="max-w-7xl mx-auto pb-12 px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col">
              <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                  <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            Fund
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            Application
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            Created
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {funds.map((fund: Fund) => (
                          <tr
                            key={fund.fundId}
                            onClick={() => {
                              navigate("/funds/" + fund.fundId);
                            }}
                            className="hover:bg-gray-50 hover:cursor-pointer"
                          >
                            <td className="px-6 py-4 whitespace-nowrap">
                              <div className="flex items-center">
                                <div>
                                  <div className="text-lg font-medium text-green-600 underline hover:no-underline">
                                    {fund.name}
                                  </div>
                                  <div className="text-sm text-gray-500">
                                    {fund.fundId}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <div className="text-sm text-green-600 underline hover:no-underline">
                                <a
                                  href={fund.applicationLink}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  View Application
                                </a>
                              </div>
                              <div className="text-sm text-gray-500"></div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              {fund.created}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      )}
    </div>
  );
};

export default Funds;
